(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-header-block"] && !Shopify.designMode) return;
  try {
    
  let button = document.querySelectorAll('#page-header-button');
  console.log('button');
  console.log(button[0]);

  function clickButtonEvent(event) {
    event.preventDefault();
    console.log(event);
    console.log(event.target.parentElement.getAttribute('href'));

    el = document.querySelectorAll(event.target.parentElement.getAttribute('href'));
    console.log(el);

    el[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  button.forEach((item) => {
    item.addEventListener('click', clickButtonEvent);
  });
  // console.log('done');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-subnav"] && !Shopify.designMode) return;
  try {
    
  let elements = document.querySelectorAll('.anchor-button');
  let sections = document.querySelectorAll('.content-stack-row');
  let mobileLeft = document.getElementById('mobile-sub-nav-nav-left');
  let mobileRight = document.getElementById('mobile-sub-nav-nav-right');

  function clickEvent(event) {
    event.preventDefault();
    el = document.querySelectorAll(event.target.getAttribute('href'));

    el[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  elements.forEach((item) => {
    item.addEventListener('click', clickEvent);
  });

  function subNavClickEventPrev(event) {
    event.preventDefault();
    activeLabel = document.querySelectorAll('.mobile-sub-nav-label:not(.hidden)')[0];

    el = document.querySelectorAll(activeLabel.dataset.linkSlug);
    prevEl = el[0].previousSibling.previousElementSibling;

    prevEl.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  mobileLeft.addEventListener('click', subNavClickEventPrev);

  function subNavClickEventNext(event) {
    event.preventDefault();
    activeLabel = document.querySelectorAll('.mobile-sub-nav-label:not(.hidden)')[0];

    el = document.querySelectorAll(activeLabel.dataset.linkSlug);
    nextEl = el[0].nextSibling.nextElementSibling;

    nextEl.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  mobileRight.addEventListener('click', subNavClickEventNext);

  let observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < 0.6) {
          let querySlug = ".anchor-button[href='#" + entry.target.getAttribute('id') + "']";
          let button = document.querySelectorAll(querySlug)[0];
          button.classList.remove('active');
        } else {
          let querySlug = ".anchor-button[href='#" + entry.target.getAttribute('id') + "']";
          let button = document.querySelectorAll(querySlug)[0];
          button.classList.add('active');

          console.log(entry);
          console.log(querySlug);

          let mobileLabel = document.querySelectorAll('.mobile-sub-nav-label');
          let eventTargetIDSlug = '#' + entry.target.getAttribute('id');

          mobileLabel.forEach((label) => {
            if (label.dataset.linkSlug == eventTargetIDSlug) {
              label.classList.remove('hidden');
            } else {
              label.classList.add('hidden');
            }
            console.log(entry.target.getAttribute('id'));
            console.log(label.dataset.linkSlug);
          });

          console.log('mobile label');
          console.log(mobileLabel);
        }
      });
    },
    { threshold: [0.25, 0.5, 0.75, 1] }
  );

  sections.forEach((p) => {
    observer.observe(p);
    console.log(p);
  });
  

  } catch(e) { console.error(e); }
})();
})();
